"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var helpers_1 = require("./helpers");
function withObservation(WrappedComponent, options) {
    if (options === void 0) { options = {}; }
    if (!helpers_1.isObserverSupported()) {
        return WrappedComponent;
    }
    // Карточки которые сейчас видимы в зависимости от intersectionRatioThreshold
    var visibleElements = new Set();
    // Карточки которые уже считаются просмотренными
    var viewedElements = new Set();
    // Map который хранить функцию отправки события о просмотре (событие должно иметь доступ к props компонента)
    var viewedEvents = new Map();
    // Хранит очередь событий, которые ожидают отправки
    var eventsQueue = [];
    var refreshIntervalID = null;
    var _a = options.onChange, onChange = _a === void 0 ? function () { } : _a, _b = options.intersectionRatioThreshold, intersectionRatioThreshold = _b === void 0 ? 0.5 : _b, _c = options.intersectionViewTimeThreshold, intersectionViewTimeThreshold = _c === void 0 ? 1000 : _c, _d = options.rootMargin, rootMargin = _d === void 0 ? '0px' : _d, _e = options.root, root = _e === void 0 ? null : _e, _f = options.onChangeDebounceInterval, onChangeDebounceInterval = _f === void 0 ? 1500 : _f;
    function intersectionCallback(elements) {
        elements.forEach(function (element) {
            if (!helpers_1.isHTMLElement(element.target)) {
                return;
            }
            if (element.isIntersecting && element.intersectionRatio >= intersectionRatioThreshold) {
                addVisibleElement(element);
            }
            else {
                if (Number(element.target.dataset.totalViewTime) >= intersectionViewTimeThreshold) {
                    checkVisibleElement(element.target);
                }
                else {
                    removeVisibleElement(element.target);
                }
            }
        });
    }
    var cardsObserver = new IntersectionObserver(intersectionCallback, {
        root: root,
        rootMargin: rootMargin,
        threshold: [0, intersectionRatioThreshold],
    });
    function checkVisibleElement(element) {
        if (visibleElements.has(element)) {
            if (Number(element.dataset.totalViewTime) >= intersectionViewTimeThreshold) {
                moveElementToViewed(element);
            }
        }
    }
    function moveElementToViewed(element) {
        if (!viewedElements.has(element)) {
            viewedElements.add(element);
            var viewedEvent = viewedEvents.get(element);
            if (viewedEvent != null) {
                viewedEvent(element);
            }
        }
        removeVisibleElement(element);
    }
    function removeVisibleElement(element) {
        visibleElements.delete(element);
        if (visibleElements.size === 0 && refreshIntervalID !== null) {
            window.clearInterval(refreshIntervalID);
            refreshIntervalID = null;
        }
    }
    function removeViewedElement(element) {
        viewedElements.delete(element);
        visibleElements.delete(element);
        viewedEvents.delete(element);
    }
    function updateAdTimer(element) {
        var lastStarted = element.dataset.lastViewStarted;
        var currentTime = performance.now();
        if (lastStarted) {
            var diff = currentTime - Number(lastStarted);
            element.dataset.totalViewTime =
                String(Number(element.dataset.totalViewTime) + diff);
        }
        element.dataset.lastViewStarted = String(currentTime);
    }
    function handleRefreshInterval() {
        visibleElements.forEach(function (element) {
            updateAdTimer(element);
            checkVisibleElement(element);
        });
    }
    var sendEvents = debounce_1.default(function () {
        onChange(eventsQueue);
        eventsQueue = [];
    }, onChangeDebounceInterval);
    function onChangeDebounce(props, isViewed) {
        eventsQueue.push({ props: props, isViewed: isViewed });
        sendEvents();
    }
    function addVisibleElement(_a) {
        var time = _a.time, target = _a.target;
        if (!helpers_1.isHTMLElement(target) || visibleElements.has(target)) {
            return;
        }
        target.dataset.lastViewStarted = String(time);
        target.dataset.totalViewTime = '0';
        visibleElements.add(target);
        if (refreshIntervalID === null) {
            window.setInterval(handleRefreshInterval, intersectionViewTimeThreshold);
        }
    }
    return /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.observe = function () {
                if (_this.containerRef.current === null) {
                    return;
                }
                var element = _this.containerRef.current;
                onChangeDebounce(_this.props, false);
                viewedEvents.set(element, function () { return onChangeDebounce(_this.props, true); });
                cardsObserver.observe(element);
            };
            _this.unobserve = function () {
                if (_this.containerRef.current === null) {
                    return;
                }
                var element = _this.containerRef.current;
                cardsObserver.unobserve(element);
                removeViewedElement(element);
            };
            if (typeof React.createRef === 'function') {
                _this.containerRef = React.createRef();
            }
            else {
                _this.containerRef = { current: null };
            }
            return _this;
        }
        class_1.prototype.componentDidMount = function () {
            this.observe();
        };
        class_1.prototype.componentWillUnmount = function () {
            this.unobserve();
        };
        class_1.prototype.componentDidUpdate = function (prevProps) {
            if (this.props.observerKey !== prevProps.observerKey) {
                this.unobserve();
                this.observe();
            }
        };
        class_1.prototype.render = function () {
            return React.createElement(WrappedComponent, tslib_1.__assign({ containerRef: this.containerRef }, this.props));
        };
        return class_1;
    }(React.Component));
}
exports.withObservation = withObservation;
